<template>
  <div class="video-grid">
    <p v-if="videos.length === 0">Coming soon</p>
    <div v-else>
      <div
        class="category"
        v-for="(cat, catIdx) in videosByCategory"
        :key="catIdx"
      >
        <p v-if="cat[0] !== 'undefined'" class="category-name">{{ cat[0] }}</p>
        <div
          class="columns"
          v-for="(videos, chunkIdx) in cat[1]"
          :key="chunkIdx"
        >
          <div
            class="column is-one-third"
            v-for="vid in videos"
            :key="vid.videoId"
          >
            <VideoGridItem :video="vid" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import VideoGridItem from "./VideoGridItem";

export default {
  name: "VideoGrid",
  props: ["videos"],
  components: {
    VideoGridItem,
  },
  computed: {
    videosByCategory() {
      // group lessons by category
      const grouped = _.groupBy(this.videos, (l) => l.category);
      // turn the grouped by category into 2d array like [catName, [{}, {}, ...]]
      return Object.keys(grouped).map((key) => {
        // to display 3 items per row
        const chunked = _.chunk(grouped[key], 3);
        return [key, chunked];
      });
    },
  },
};
</script>
<style scoped>
.category {
  margin-bottom: 24px;
}
.category-name {
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  margin-bottom: 12px;
}
</style>
